import React from "react";
import { Input } from '@progress/kendo-react-inputs';



function formatDate(d) {
    if (!d) return '';
    // If already in yyyy-MM-dd format, return as is
    if (typeof d === 'string') {
        if (/^\d{4}-\d{2}-\d{2}$/.test(d)) return d;
        // Try to parse as date string
        const parsed = Date.parse(d);
        if (isNaN(parsed)) return '';
        d = new Date(parsed);
    }
    if (!(d instanceof Date) || isNaN(d.getTime())) return '';
    const day = String(d.getUTCDate()).padStart(2, '0');
    const month = String(d.getUTCMonth() + 1).padStart(2, '0');
    const year = d.getUTCFullYear();
    return `${year}-${month}-${day}`;
}

const InputDate = ({ name, label, defaultValue, valid, value, _handleChange }) => {
    // Only allow yyyy-MM-dd or empty string for the input value
    const getInputValue = (v) => {
        if (!v) return '';
        if (typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)) return v;
        // Try to format if valid date
        const d = new Date(v);
        if (!isNaN(d.getTime())) return formatDate(d);
        return '';
    };

    // Always output a yyyy-MM-dd string on change
    const handleChange = (e) => {
        let val = e.value;
        // If value is a Date object, format it
        if (val instanceof Date && !isNaN(val.getTime())) {
            val = formatDate(val);
        }
        // If value is a string but not in yyyy-MM-dd, try to format
        else if (typeof val === 'string' && !/^\d{4}-\d{2}-\d{2}$/.test(val)) {
            const d = new Date(val);
            if (!isNaN(d.getTime())) {
                val = formatDate(d);
            } else {
                val = '';
            }
        }
        // Call the parent handler with the formatted string
        if (_handleChange) {
            // Simulate a synthetic event with the formatted value
            _handleChange({ ...e, value: val });
        }
    };

    if (!label) {
        return (
            <Input
                type="date"
                name={name}
                valid={valid}
                onChange={handleChange}
                value={getInputValue(value)}
                defaultValue={getInputValue(defaultValue)}
            />
        );
    }
    else{
        return (
            <div style={{paddingRight: '20px'}}>
                <label>{label}: </label>
                <br></br>
                <Input
                    type="date"
                    name={name}
                    valid={valid}
                    onChange={handleChange}
                    value={getInputValue(value)}
                    defaultValue={getInputValue(defaultValue)}
                />
                <br></br>
            </div>
        );
    }
    
};
export default InputDate;